export default function Footer() {
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const headerHeight = 72;
      const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <a
              href="#hero"
              onClick={(e) => handleNav(e, '#hero')}
              className="text-xl font-heading font-bold text-primary-400 whitespace-nowrap cursor-pointer"
            >
              91麻豆
            </a>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-xs">
              91麻豆免费视频网站 — 专注91高清视频在线观看的专业平台，提供海量91国产高清视频与超清视频在线观看资源，每日更新，流畅播放，畅享高品质影视在线体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#hero" onClick={(e) => handleNav(e, '#hero')} className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center cursor-pointer hover:bg-primary-500/50 transition-colors">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => handleNav(e, '#hero')} className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center cursor-pointer hover:bg-primary-500/50 transition-colors">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => handleNav(e, '#hero')} className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center cursor-pointer hover:bg-primary-500/50 transition-colors">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-white mb-5">快速导航</h3>
            <div className="space-y-3">
              <a href="#features" onClick={(e) => handleNav(e, '#features')} className="block text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">平台优势</a>
              <a href="#media" onClick={(e) => handleNav(e, '#media')} className="block text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">热门精选</a>
              <a href="#cards" onClick={(e) => handleNav(e, '#cards')} className="block text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">专题推荐</a>
              <a href="#ranking" onClick={(e) => handleNav(e, '#ranking')} className="block text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">热门榜单</a>
              <a href="#index" onClick={(e) => handleNav(e, '#index')} className="block text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">主题索引</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-white mb-5">内容分类</h3>
            <div className="space-y-3">
              <span className="block text-sm text-foreground-300 whitespace-nowrap">91国产高清视频</span>
              <span className="block text-sm text-foreground-300 whitespace-nowrap">超清视频在线观看</span>
              <span className="block text-sm text-foreground-300 whitespace-nowrap">高清影视在线</span>
              <span className="block text-sm text-foreground-300 whitespace-nowrap">91高清视频在线</span>
              <span className="block text-sm text-foreground-300 whitespace-nowrap">国产高清视频合集</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-white mb-5">合作伙伴</h3>
            <p className="text-xs text-foreground-400 leading-relaxed">
              91麻豆免费视频网站与多家优质内容供应商保持长期合作关系，致力于为用户提供丰富的91高清视频在线观看资源。
            </p>
            <div className="mt-4 text-xs text-foreground-400">
              <p className="whitespace-nowrap">联系邮箱：contact@91madou.com</p>
              <p className="mt-1 whitespace-nowrap">服务时间：7×24小时</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 91麻豆免费视频网站. All Rights Reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <span className="cursor-pointer hover:text-foreground-200 transition-colors whitespace-nowrap">服务条款</span>
              <span className="cursor-pointer hover:text-foreground-200 transition-colors whitespace-nowrap">隐私政策</span>
              <span className="cursor-pointer hover:text-foreground-200 transition-colors whitespace-nowrap">版权声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}